import React, { useEffect, useState } from 'react';
import Modal from './Modal';
import FlexWrapper from '../../layouts/FlexWrapper';
import Divider from '../Divider';
import DetailField from '../../layouts/Shared/DetailSection/DetailField';
import { addYears, format, subYears, lastDayOfMonth } from 'date-fns';
import SelectDetailField from '../../layouts/Shared/DetailSection/SelectDetailField';
import "./StartProcessModal.scss"
import { useRemote, useStorage } from '../../Utils/Utils';
import ErrorBlockMessage from '../../layouts/Shared/Prompts/ErrorBlockMessage';

const TimeFrame = {
	// WEEKLY:  "WEEKLY",
	"Monthly": "MONTHLY",
	"Quarterly": "QUARTERLY",
	"Half Yearly": "HALF_YEARLY",
	"Yearly": "YEARLY",
	// CUSTOM: "CUSTOM",
}

const currentYear = new Date()
// this is for Disclose testing purposes.  It would be good to make this configurable before this goes to production.  Rowena
const yearsList = [
	format(subYears(currentYear, 9), "yyyy"), 
	format(subYears(currentYear, 8), "yyyy"), 
	format(subYears(currentYear, 7), "yyyy"), 
	format(subYears(currentYear, 6), "yyyy"), 
	format(subYears(currentYear, 5), "yyyy"), 
	format(subYears(currentYear, 4), "yyyy"), 
	format(subYears(currentYear, 3), "yyyy"), 
	format(subYears(currentYear, 2), "yyyy"),
	format(subYears(currentYear, 1), "yyyy"), 
	format(currentYear, "yyyy"), 
	format(addYears(currentYear, 1), "yyyy")]
const timePeriods = ["Monthly", "Quarterly", "Half Yearly", "Yearly"]
const quarterlyPublishDate = ["Q1", "Q2", "Q3", "Q4"]
const biannual = ["H1", "H2"]
// const weeklyPublishDate = ["17th March - 23rd March", "24th March - 30th March", "31st March - 6th April", "7th April - 13th April", "14th April - 20th April"]
// const halfYearlyPublishDate = ["Jan - Jun 2025", "Jul - Dec 2025", "Jan - Jun 2026", "Jul - Dec 2026", "Jan - Jun 2027", "Jul - Dec 2027", "Jan - Jun 2028", "Jul - Dec 2028",]
// const yearlyPublishDate = [2020, 2021, 2022, 2023, 2024, 2025, 2026, 2027, 2028, 2029, 2030]

const dateConversions = {
	"Q1": { day: 1, month: 2 },
	"Q2": { day: 1, month: 5 },
	"Q3": { day: 1, month: 8 },
	"Q4": { day: 1, month: 11 },
	"H1": { day: 1, month: 5 },
	"H2": { day: 1, month: 11 }
};

const StartProcessModal = ({ handleClose, cancelButton, header, refreshList }) => {
	const [template, setTemplate] = useState(null)
	const [timePeriod, setTimePeriod] = useState(null)
	const [publishDate, setPublishDate] = useState(null)
	const [publishYear, setPublishYear] = useState(null)
	const [templates, setTemplates] = useState([])
	const [templatesWithFullData, setTemplatesWithFullData] = useState([])
	const [showError, setShowError] = useState(null)
	const storage = useStorage()
	const remote = useRemote()
	const selectedTemplateWithFullData = templatesWithFullData.find((val) => { return template === val.templateName })

	useEffect(() => {
		storage.getOrFetch("/workflows/start/available/template")
			.then((res) => {
				res && res.data && setTemplatesWithFullData(res.data)
				res && res.data && setTemplates(res.data.map((val) => val.templateName))
			})
	}, []) // eslint-disable-line

	const hasPublishDate = timePeriod === "Yearly" ? !!publishYear : !!publishDate
	const isInvalid = !template || !timePeriod || !hasPublishDate

	function handleKeyDown(e) {
		if (e.key === "Escape") {
			handleClose()
		}
	}

	const submit = () => {
		let isoDate;

		if (timePeriod === "Monthly" || timePeriod === "Custom") {
			isoDate = publishDate;
		} else if (timePeriod === "Quarterly" || timePeriod === "Half Yearly") {
			const { day, month } = dateConversions[publishDate];
			isoDate = format(lastDayOfMonth(new Date(+publishYear, month, day)), "yyyy-MM-dd");
		} else if (timePeriod === "Yearly") {
			isoDate = format(lastDayOfMonth(new Date(+publishYear, 11)), "yyyy-MM-dd");
		}

		const templateInfo = templatesWithFullData.find((val) => {return template === val.templateName })

		const dto = {
			templateId: templateInfo.templateId,
			timeFrame: TimeFrame[timePeriod],
			publishDate: isoDate
		};

		remote.post(`/workflows/workflow/create/${templateInfo.workflowName}`, dto)
			.then((res) => {
				if (res.success) {
					refreshList && refreshList()
					handleClose()
				} else {
					console.log("MESSAGE", res.message);
					console.log("Data", res.data);
					setShowError(res.data);
				}
			})
			.catch((res) => {
				console.error("An error occurred while starting process", res)
			})


	};

	return (
		<Modal
			header={header ? header : "Confirm"}
			handleClose={handleClose}
			cancelButton={{ ...cancelButton }}
			confirmButton={{ disabled: isInvalid, label: "Confirm", onClick: () => submit() }}
			onKeyDown={handleKeyDown}
			modalStyle={{ minWidth: "640px" }}
		>
			<Divider marginTop="-0.5rem" spacingBottom="xl" />

			<SelectDetailField
				options={templates.map(v => { return { label: v, value: v } })}
				editMode={true}
				placeholder="Template"
				value={template === null ? null : { label: template, value: template }}
				onChange={(option) => {setTemplate(option.value); setTimePeriod(null); setPublishDate(null); setPublishYear(null)}}
			/>
			<FlexWrapper gap="m" style={{ marginTop: "1rem", width: "100%" }} className={"start-process-timing"}>
				<SelectDetailField
					options={timePeriods.map(v => { return { label: v, value: v } }).filter(v => selectedTemplateWithFullData && selectedTemplateWithFullData.acceptedTimeFrame ? selectedTemplateWithFullData.acceptedTimeFrame.includes(v.value.toLocaleUpperCase()): true)}
					editMode={true}
					placeholder="Time Period"
					value={timePeriod === null ? null : { label: timePeriod, value: timePeriod }}
					onChange={(option) => { setTimePeriod(option.value); setPublishDate(null); setPublishYear(null) }}
					width="m-288"
				/>
				<PublishDateDefinedByTimePeriod
					timePeriod={timePeriod}
					publishDate={publishDate}
					publishYear={publishYear}
					setPublishDate={setPublishDate}
					setPublishYear={setPublishYear}
					disabled={timePeriod}
				/>
			</FlexWrapper>
			{showError && showError.map((val) => <ErrorBlockMessage style={{marginTop: "1rem"}} >{val}</ErrorBlockMessage>)}
		</Modal>
	);
}

export default StartProcessModal;

const PublishDateDefinedByTimePeriod = ({ timePeriod, publishDate, setPublishDate, publishYear, setPublishYear, disabled }) => {

	if (timePeriod === "Monthly") {
		return <DetailField
			type="month"
			variant="bordered-light"
			editMode={true}
			onChange={(e) => { setPublishDate(format(lastDayOfMonth(new Date(e.target.value)), "yyyy-MM-dd")) }}
			// label="Publish Date"
			style={{ width: "288px", border: "none", backgroundColor: "#F4F6FA" }}
		/>
	}
	if (timePeriod === "Custom") {
		return <DetailField
			type="date"
			variant="bordered-light"
			editMode={true}
			onChange={(e) => { setPublishDate(format(lastDayOfMonth(new Date(e.target.value)), "yyyy-MM-dd")); }}
			// label="Publish Date"
			style={{ width: "288px" }}
		/>
	}

	let list = []
	switch (timePeriod) {
		// case "Weekly":
		// 	list = weeklyPublishDate
		// 	break;
		case "Quarterly":
			list = quarterlyPublishDate
			break;
		case "Half Yearly":
			list = biannual
			break
		case "Yearly":
			list = yearsList
			break;
		default:
			list = []
			break;
	}

	return <>
		{(timePeriod === "Quarterly" || timePeriod === "Half Yearly" || timePeriod === "Yearly") &&
			<SelectDetailField
				options={yearsList.map(v => { return { label: v, value: v } })}
				editMode={true}
				placeholder="Publish Year"
				value={publishYear === null ? null : { label: publishYear, value: publishYear }}
				onChange={(option) => setPublishYear(option.value)}
				width={timePeriod === "Quarterly" || timePeriod === "Half Yearly" ? "xs" : "m-288"}
			/>}
		{timePeriod !== "Yearly" && <SelectDetailField
			options={list.map(v => { return { label: v, value: v } })}
			editMode={true}
			placeholder="Publish Date"
			value={publishDate === null ? null : { label: publishDate, value: publishDate }}
			onChange={(option) => setPublishDate(option.value)}
			width={timePeriod === "Quarterly" || timePeriod === "Half Yearly" ? "xs" : "m-288"}
		/>}
	</>
}